<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />
    
    <v-row>
      <v-col cols="12" md="8" sm="8">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" md="4" sm="4">
        <v-switch 
          v-model="entry.enabled"           
          inset
          :label="entry.enabled ? 'Ativa' : 'Inativa'"          
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>

      <v-col cols="12" sm="8">
        <v-autocomplete
          v-model="entry.bankAccountTypeId"
          v-bind="getObject('bankAccountTypeId')"
          label="Tipo de Conta"
          :items="extraData.accountGlobalSharedContext.allBankAccountTypes"
          item-value="id"
          item-text="name"
          @input="bankAccountTypeSelected"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="8" sm="6" md="3">
        <MaskedTextField
          v-bind="getObject('initialBalance')"
          :inputData.sync="entry.initialBalance"
          mask-type="currency_negative"
          label="Saldo Inicial"
          prefix="R$"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      

      <!-- <v-col cols="3">
        <DateField
          :inputData.sync="entry.initialBalanceDate"
          v-bind="getObject('iinitialBalanceDate')"
          label="Data do Saldo Inicial"
          :hasTodayButton="true"
          :hasTodayDate="true"
        />
      </v-col> -->

      <v-col cols="12"  v-if="entry.bankAccountType && !entry.bankAccountType.isCashKeeper">
        <v-autocomplete
          v-model="entry.bankId"
          v-bind="getObject('bankId')"
          label="Banco"
          :items="extraData.globalContext.allBanks"
          item-value="id"
          item-text="nameWithCode"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="entry.bankAccountType && !entry.bankAccountType.isCashKeeper">
        <v-text-field
          v-model="entry.accountNumber"
          v-bind="getObject('accountNumber')"
          label="Número da Conta"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="entry.bankAccountType && !entry.bankAccountType.isCashKeeper">
        <v-text-field
          v-model="entry.agencyNumber"
          v-bind="getObject('agencyNumber')"
          label="Número da Agência"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    if (this.entry.bankAccountTypeId) {
      this.bankAccountTypeSelected();
    }
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    bankAccountTypeSelected: function() {
      this.entry.bankAccountType = this.extraData.accountGlobalSharedContext.allBankAccountTypes.find(obj => obj.id == this.entry.bankAccountTypeId);
      if (this.entry.bankAccountType.isCashKeeper) {
        this.entry.bankId = null;
        this.entry.accountNumber = null;
        this.entry.agencyNumber = null;
      }
    },
  }
};
</script>

<style scoped></style>
